
import { HeroServiceSection } from "@/components/services/HeroServiceSection";
import { wisdomToothData } from "./wisdomToothData";

export const WisdomToothHero = () => {
  const handleBookAppointment = () => {
    window.open("https://www.healthcoco.com/nagpur/doctor/dr-hemant-asrani-endodontist-dentist/USRH249D644", "_blank");
  };

  return (
    <HeroServiceSection 
      title="Wisdom Tooth Removal in Nagpur"
      description="Expert and gentle wisdom tooth extraction at Asrani Dental, Sadar, Nagpur to eliminate pain and prevent future complications."
      onButtonClick={handleBookAppointment}
    />
  );
};
